import { V2 } from 'types/swagger/clarifai-api';
import { objectToQueryParams } from 'utils/request/objectToQueryParams';
import { fetch } from 'utils/request';

export const listModelVersions = (params: V2.V2ListModelVersions.RequestParams, query: V2.V2ListModelVersions.RequestQuery) => {
  const queryParams = objectToQueryParams(query);

  return fetch<V2.V2ListModelVersions.ResponseBody>({
    path: `/api/_api/v2/users/${params.userAppIdUserId}/apps/${params.userAppIdAppId}/models/${encodeURIComponent(
      params.modelId,
    )}/versions${queryParams}`,
    method: 'GET',
  });
};
